// extracted by mini-css-extract-plugin
export default {"banner":"page-top-banner_banner__xXv2j","text":"page-top-banner_text__kHMbi"};